<template>
  <div>
    <el-tabs :model="activeName">
      <el-tab-pane
        :label="item.version"
        :name="index + ''"
        v-for="(item, index) in baseInfo"
        :key="index + ''"
      >
        <div class="card card3">
          <el-row>
            <el-col
              :span="24"
              v-for="(item2, index2) in item.metaPropList"
              :key="index2"
            >
              <div class="content">
                <div v-if="item2.type == 1">
                  <div class="content_title">{{ item2.cname }}</div>
                  <div class="content_text" v-html="item2.propValue"></div>
                </div>
                <div v-else>
                  <div class="content_title">{{ item2.cname }}</div>
                  <div
                    :id="`wangEditor_yqjxsq_result_${index}_${index2}`"
                  ></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getClosingApplyResult } from "@/api/course.js";

export default {
  name: "courseJxsq",
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      addDialog: false,
      editDialog: false,
      activeName: "0",
      baseInfo: [],
      editorList: [],
    };
  },
  created() {
    if (!this.mxParams) {
      this.mxParams = this.$route.query;
    }

    getClosingApplyResult({
      courseId: this.mxParams.id,
      reviewTimes: "2",
    }).then((res) => {
      if (res.code == 0) {
        this.baseInfo = res.data;
      }
    });
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.baseInfo && this.baseInfo.length > 0) {
        for (let i = 0; i < this.baseInfo.length; i++) {
          for (let j = 0; j < this.baseInfo[i].metaPropList.length; j++) {
            if (this.baseInfo[i].metaPropList[j].type == 2) {
              let editor = new wangEditor(
                `#wangEditor_yqjxsq_result_${i}_${j}`
              );
              editor = this.editorConfig(editor);
              editor.txt.html(this.baseInfo[i].metaPropList[j].propValue);
              // editor.disable();
              document.querySelector(
                `#wangEditor_yqjxsq_result_${i}_${j} .w-e-text-container`
              ).style.backgroundColor = "#f3f3f3";
              document.querySelector(
                `#wangEditor_yqjxsq_result_${i}_${j} .w-e-toolbar`
              ).style.backgroundColor = "#f3f3f3";
              this.editorList.push(editor);
            }
          }
        }
        clearInterval(timer);
      }
    }, 50);
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      return editor;
    },
    editCy(row) {
      this.editDialog = true;
      this.mxParams.id = row.id;
    },
    getSon(temp) {
      this.addDialog = false;
      this.editDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 10%;
  }
}
.card3 {
  .content_title {
    margin-left: 30px;
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 15px;
  }
}

.card:nth-of-type(1) {
  margin-top: 0;
}
</style>